import { createSelector } from 'reselect';
import { CarrierFormField } from '~/types/CarrierFormField';
import { ApplicationState } from '../store';

export const getCarrierFormFieldsStore = (state: ApplicationState) => state.carrierFormFields;

export const getCarrierFormFields = createSelector(
  getCarrierFormFieldsStore,
  (carrierFormFieldsStore): readonly CarrierFormField[] => carrierFormFieldsStore.carrierFormFields,
);

export const getIsFetchingCarrierFormFields = createSelector(
  getCarrierFormFieldsStore,
  (carrierFormFieldsStore): boolean => carrierFormFieldsStore.isFetchingCarrierFormFields,
);

export const getCarrierFormFieldsErrorMessage = createSelector(
  getCarrierFormFieldsStore,
  (carrierFormFieldsStore): string => carrierFormFieldsStore.errorMessage,
);

export const getCarrierFormFieldValidations = createSelector(
  getCarrierFormFieldsStore,
  (carrierFormFieldsStore): { [key: string]: ((data: string) => void)[] } =>
    carrierFormFieldsStore.carrierFormFieldValidations,
);
